import { useEffect, useState } from 'react';
import { loadAvailableTokens, type AvailableTokens } from '../services/token-list';
import { useBridgeStore } from './useBridgeStore';
import { NATIVE_SOL } from '../config/tokens';

/**
 * The assets this UI may offer, resolved from the bridge contract and the
 * build's allowlist. Starts as SOL-only and stays that way if the contract
 * cannot be reached, so nothing selectable is ever a token the bridge would
 * refuse.
 *
 * Also keeps the store honest: a token that stops being available while it
 * is selected gets swapped back to the first one that is.
 */
export function useAvailableTokens(): AvailableTokens & { loading: boolean } {
  const { selectedToken, setSelectedToken } = useBridgeStore();
  const [loading, setLoading] = useState(true);
  const [resolved, setResolved] = useState<AvailableTokens>({
    tokens: [NATIVE_SOL],
    registryReachable: false,
    withheldByAllowlist: [],
  });

  useEffect(() => {
    let cancelled = false;
    loadAvailableTokens().then((result) => {
      if (cancelled) return;
      setResolved(result);
      setLoading(false);
    });
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    const { tokens } = resolved;
    if (tokens.length === 0) return;
    if (tokens.some((t) => t.splMint === selectedToken.splMint)) return;
    setSelectedToken(tokens[0]);
  }, [resolved, selectedToken.splMint, setSelectedToken]);

  return { ...resolved, loading };
}
